import React from 'react';

type Props = {
  open: boolean;
  title?: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
  destructive?: boolean;
};

const ConfirmationModal: React.FC<Props> = ({
  open,
  title = 'Please confirm',
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  onConfirm,
  onCancel,
  destructive = false,
}) => {
  if (!open) return null;

  return (
    <div className="zivo-global-modal-overlay" onClick={onCancel} role="presentation">
      <div
        className="zivo-global-modal-content"
        role="dialog"
        aria-modal="true"
        aria-label={title}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="zivo-global-modal-header">
          <h3>{title}</h3>
        </div>
        <div className="zivo-global-modal-body">
          <p>{message}</p>
        </div>
        <div className="zivo-global-modal-footer" style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button className="zivo-global-modal-button" onClick={onCancel} type="button">
            {cancelLabel}
          </button>
          <button
            className="zivo-global-modal-button"
            onClick={onConfirm}
            type="button"
            style={destructive ? { backgroundColor: '#b91c1c', borderColor: '#b91c1c' } : undefined}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
